import React, { useState, useEffect } from "react"
import { InputGroupAddon } from "reactstrap"

import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  CardTitle,
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupText,
  FormFeedback,
  Form,
  FormGroup,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import withRouter from "components/Common/withRouter"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import avatar from "../../assets/images/users/avatar-1.jpg"
// actions
import { editProfile, resetProfileFlag } from "../../store/actions"
import axios from "axios"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEye,
  faEyeSlash,
  faUser,
  faEnvelope,
  faLock,
  faMapMarkerAlt,
  faUserTag,
} from "@fortawesome/free-solid-svg-icons"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { useNavigate } from "react-router-dom"
import apiURl from "url"

const UserProfile = () => {
  //meta title
  document.title = "Profile"
  const navigate = useNavigate()

  const [showPassword, setShowPassword] = useState(false)
  const [showFPassword, setShowFPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const togglePasswordVisibility2 = () => {
    setShowFPassword(!showFPassword)
  }

  const [initialCity, setInitialCity] = useState("")
  const [initialRole, setInitialRole] = useState("")

  const ID = localStorage.getItem("login_id")

  const fetchUserDataByID = id => {
    const URL = `${apiURl}/fetchUserByID`
    axios
      .post(URL, { id })
      .then(response => {
        if (response.data.status === "success") {
          const UserDataByID = response.data.UserDataByID
          if (UserDataByID.length > 0) {
            formik.setValues({
              fullName: UserDataByID[0]?.full_name || "",
              email: UserDataByID[0]?.email_ || "",
              city: UserDataByID[0]?.city_ || "",
              role: UserDataByID[0]?.role_ || "",
              password: "",
              confirmPassword: "",
            })
            setInitialCity(UserDataByID[0]?.city_ || "")
            setInitialRole(UserDataByID[0]?.role_ || "")
          } else {
            console.error("No user data found")
          }
        } else {
          console.error("Failed to fetch user data:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching user data:", error)
      })
  }

  useEffect(() => {
    fetchUserDataByID(ID)
  }, [ID])

  // Password validation regex: at least 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special
  const passwordRegex =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/

  const validationSchema = Yup.object({
    fullName: Yup.string()
      .min(2, "Full Name must be at least 2 characters")
      .required("Full Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    city: Yup.string().required("City is required"),
    role: Yup.string().required("Role is required"),
    password: Yup.string()
      .matches(
        passwordRegex,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and be at least 8 characters long"
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm Password is required"),
  })

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      city: "",
      role: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: values => {
      const userData = {
        edit_id: parseInt(ID),
        fullname: values.fullName,
        email: values.email,
        city: values.city,
        password: values.password,
        role: values.role,
      }
      const URL = `${apiURl}/EditUser`
      axios
        .post(URL, userData)
        .then(response => {
          if (response.data.status === "success") {
            fetchUserDataByID(ID)
            toastr.success("User updated successfully")
            navigate("/")
          } else {
            toastr.error(response.data.message || "Failed to update user")
          }
        })
        .catch(error => {
          console.log(error)
          toastr.error("An error occurred while updating the user")
        })
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="User" breadcrumbItem="Profile" />

          <Row>
            <Col xl={8}>
              <Card className="shadow-lg border-0">
                <CardBody className="p-4">
                  <Form onSubmit={formik.handleSubmit}>
                    <Row className="g-3">
                      <Col md={6}>
                        <FormGroup>
                          <Label htmlFor="fullName" className="form-label">
                            <FontAwesomeIcon icon={faUser} className="me-1" />{" "}
                            Full Name
                          </Label>
                          <Input
                            type="text"
                            className={`form-control ${
                              formik.touched.fullName && formik.errors.fullName
                                ? "is-invalid"
                                : ""
                            }`}
                            id="fullName"
                            placeholder="Enter Full Name"
                            {...formik.getFieldProps("fullName")}
                          />
                          {formik.touched.fullName &&
                            formik.errors.fullName && (
                              <FormFeedback type="invalid">
                                {formik.errors.fullName}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label htmlFor="email" className="form-label">
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              className="me-1"
                            />{" "}
                            Email
                          </Label>
                          <Input
                            type="email"
                            className={`form-control ${
                              formik.touched.email && formik.errors.email
                                ? "is-invalid"
                                : ""
                            }`}
                            id="email"
                            placeholder="Enter Email"
                            {...formik.getFieldProps("email")}
                          />
                          {formik.touched.email && formik.errors.email && (
                            <FormFeedback type="invalid">
                              {formik.errors.email}
                            </FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label htmlFor="password" className="form-label">
                            <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                            Password
                          </Label>
                          <InputGroup>
                            <Input
                              type={showPassword ? "text" : "password"}
                              className={`form-control ${
                                formik.touched.password &&
                                formik.errors.password
                                  ? "is-invalid"
                                  : ""
                              }`}
                              id="password"
                              placeholder="Enter Password"
                              {...formik.getFieldProps("password")}
                            />
                            <InputGroupText
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            >
                              <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                              />
                            </InputGroupText>
                          </InputGroup>
                          {formik.touched.password &&
                            formik.errors.password && (
                              <FormFeedback type="invalid">
                                {formik.errors.password}
                              </FormFeedback>
                            )}
                          <div className="form-text">
                            Password must contain at least one uppercase letter,
                            one lowercase letter, one number, one special
                            character, and be at least 8 characters long.
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label
                            htmlFor="confirmPassword"
                            className="form-label"
                          >
                            <FontAwesomeIcon icon={faLock} className="me-1" />{" "}
                            Confirm Password
                          </Label>
                          <InputGroup>
                            <Input
                              type={showFPassword ? "text" : "password"}
                              className={`form-control ${
                                formik.touched.confirmPassword &&
                                formik.errors.confirmPassword
                                  ? "is-invalid"
                                  : ""
                              }`}
                              id="confirmPassword"
                              placeholder="Confirm Password"
                              {...formik.getFieldProps("confirmPassword")}
                            />
                            <InputGroupText
                              onClick={togglePasswordVisibility2}
                              style={{ cursor: "pointer" }}
                            >
                              <FontAwesomeIcon
                                icon={showFPassword ? faEyeSlash : faEye}
                              />
                            </InputGroupText>
                          </InputGroup>
                          {formik.touched.confirmPassword &&
                            formik.errors.confirmPassword && (
                              <FormFeedback type="invalid">
                                {formik.errors.confirmPassword}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="justify-content-end mt-4">
                      <Col sm={9}>
                        <div className="text-end">
                          <Button
                            type="submit"
                            color="primary"
                            className="w-md waves-effect waves-light"
                            disabled={formik.isSubmitting}
                          >
                            Update Profile
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
